<script setup lang="ts">
import QueueButton from '@desktop/views/Relation/Sports/components/RelationView/Header/RelationButtons/QueueButton.vue'

import StatisticsButton from './StatisticsButton.vue'
import StatusesButton from './Statuses/StatusesButton.vue'
import VerifyResultButton from './VerifyResult/VerifyResultButton.vue'
</script>

<template>
  <div class="flex flex-1 justify-end gap-2">
    <StatusesButton />
    <QueueButton />
    <VerifyResultButton />
    <StatisticsButton />
  </div>
</template>
